/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetailsStats_seller = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDistinctions_seller" | "PdpSharedDealerInfo_seller" | "PdpSharedDealerDetailsHeader_seller" | "PdpRespDealerDetailsBio_seller">;
    readonly " $refType": "PdpRespDealerDetailsStats_seller";
};
export type PdpRespDealerDetailsStats_seller$data = PdpRespDealerDetailsStats_seller;
export type PdpRespDealerDetailsStats_seller$key = {
    readonly " $data"?: PdpRespDealerDetailsStats_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetailsStats_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetailsStats_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDistinctions_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerInfo_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetailsBio_seller",
      "args": null
    }
  ]
};
(node as any).hash = '3932c9d733004404b21831fe1042b61a';
export default node;
